import ArrowBack from "@mui/icons-material/ArrowBack";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { Box, Button, Pagination } from "@mui/material";

interface PaginatorProps {
  totalPages: number;
  currentPage: number;
  onChange: (page: number) => void;
}

// Labelled Previous and Next, drawn as CursorPaginator draws them, so a list reads the same
// whichever of the two is paging it.
export const Paginator: React.FC<PaginatorProps> = ({
  totalPages,
  currentPage,
  onChange,
}) => {
  return (
    <Box display="flex" alignItems="center" gap={2}>
      <Button
        size="small"
        startIcon={<ArrowBack />}
        // No step back from the first page, nor forward from the last.
        disabled={currentPage <= 1}
        onClick={() => onChange(currentPage - 1)}
      >
        Previous
      </Button>
      <Pagination
        page={currentPage}
        count={totalPages}
        shape="rounded"
        // Its own arrow-only steps are replaced by the labelled buttons either side.
        hidePrevButton
        hideNextButton
        onChange={(_, page) => onChange(page)}
      />
      <Button
        size="small"
        endIcon={<ArrowForward />}
        disabled={currentPage >= totalPages}
        onClick={() => onChange(currentPage + 1)}
      >
        Next
      </Button>
    </Box>
  );
};
